import React from "react";
import "./MultiStepProgressBar.css";
import { ProgressBar, Step } from "react-step-progress-bar";

const MultiStepProgressBar = ({ page, onPageNumberClick, expe }) => {
  var stepPercentage = 0;
  if (page === "pageone") {
    stepPercentage = 0;
  } else if (page === "pagetwo") {
    stepPercentage = 25;

  } else if (page === "pagethree") {
    stepPercentage = 50;

  } else if (page === "pagefour") {
    stepPercentage = 75;

  }else if (page === "pagefive") {
    stepPercentage = 100;

  } else {
    stepPercentage = 0;
  }
  console.log('expe',expe)

  return (
    <ProgressBar percent={stepPercentage}>
      <Step>
        {({ accomplished, index }) => (
        <>
        {console.log('step 1 not complet',index)}
         {
          index == 0 &&  <div
          className={`indexedStep ${accomplished ? "accomplished" : null}`}
          onClick={() => onPageNumberClick("1")}
        >
          {index + 1}
          
        </div>
         }
         
        </>
        )}
      </Step>
      <Step>
        {({ accomplished, index }) => (
          <div
            className={`indexedStep ${accomplished ? "accomplished" : null}`}
            onClick={() => onPageNumberClick("2")}
          >
            {index + 1}
            {console.log('step 2 not complet',index)}
          </div>
        )}
      </Step>
      <Step>
        {({ accomplished, index }) => (
          expe == true ? <div
            className={`indexedStep ${accomplished ? "accomplished" : null}`}
            onClick={() => onPageNumberClick("3")}
          >
            {index + 1}
          </div>:null
        )}
      </Step>
      <Step>
        {({ accomplished, index }) => (
          <div
            className={`indexedStep ${accomplished ? "accomplished" : null}`}
            onClick={() => onPageNumberClick("4")}
          >
            {index + 1}
          </div>
        )}
      </Step>
      <Step>
        {({ accomplished, index }) => (
          <div
            className={`indexedStep ${accomplished ? "accomplished" : null}`}
            onClick={() => onPageNumberClick("5")}
          >
            {index + 1}
          </div>
        )}
      </Step>
   
    </ProgressBar>
  );
};

export default MultiStepProgressBar;
